import { useLocation } from 'react-router-dom';
import BreadCrumb from '../../components/breadCrumb';
import './style.scss';

function BeneficiariesAdmin() {

  const location = useLocation();
  const beneficiary = location.state;
  // STATES //

  return (
    <section className='beneficiariesTable-main-container'>
      <BreadCrumb />
      <h1 className='principal-title'>CARACTERIZACIÓN</h1>
      <section className='characterization-form'>
        <section className='form-wrapper'>
          <label htmlFor=''>
            <p className='input-title'>Tipo de identificación</p>
            <input
              type='text'
              value={beneficiary.documentType}
              className='input-form'
              readOnly
            />
          </label>

          <label htmlFor=''>
            <p className='input-title'>Número de documento</p>
            <input
              type='number'
              value={beneficiary.document}
              className='input-form'
              readOnly
            />
          </label>
          <label htmlFor=''>
            <p className='input-title'>Nombre completo</p>
            <input
              type='text'
              value={beneficiary.full_name}
              className='input-form'
              readOnly
            />
          </label>
          <label htmlFor=''>
            <p className='input-title'>Sexo</p>
            <input
              type='text'
              value={beneficiary.gender}
              className='input-form'
              readOnly
            />
          </label>

          <label htmlFor=''>
            <p className='input-title'>Fecha de nacimiento</p>
            <input
              type='text'
              value={beneficiary.birth_date?beneficiary.birth_date.substring(0,10):''}
              className='input-form form_date'
              readOnly
            />
          </label>
        </section>
        <section className='form-wrapper'>
          <label htmlFor='' className='address'>
            <p className='input-title' disabled>
              Dirección
            </p>
            <input
              type='text'
              value={beneficiary.address}
              readOnly
              className='input-form'
            />
          </label>


          <label htmlFor='' className='type'>
            <p className='input-title'>Zona</p>
            <input
              value={beneficiary?.zone?.name}
              readOnly
              name='type'
              type='text'
              className='input-form'
            />
          </label>
          <label htmlFor='' className='type'>
            <p className='input-title'>Comuna</p>
            <input
              value={beneficiary?.municipality?.name}
              readOnly
              name='type'
              type='text'
              className='input-form'
            />
          </label>
          <label htmlFor='' className='type'>
            <p className='input-title'>Barrio</p>
            <input
              value={beneficiary?.neighborhood?.name}
              readOnly
              name='type'
              type='text'
              className='input-form'
            />
          </label>
          <label htmlFor='' className='type'>
            <p className='input-title'>Celular</p>
            <input
              value={beneficiary?.cell_phone}
              readOnly
              name='type'
              type='text'
              className='input-form'
            />
          </label>

          <label htmlFor=''>
            <p className='input-title'>Correo electrónico</p>
            <input
              value={beneficiary?.email}
              placeholder='Ejm: Carlos187@gmail.com'
              type='email'
              readOnly
              className='input-form'
            />
          </label>
        </section>
        <section className='form-wrapper'>
          <label htmlFor='' className='scolarity'>
            <p className='input-title'>Nivel de escolaridad</p>
            <input
              value={beneficiary?.scholarship_value}
              type='text'
              className='input-form'
              readOnly
            />
          </label>
        </section>
        <section className='form-wrapper'>
          <div className='disabilitie-top-container'>
            <label htmlFor='' className='scolarity'>
              <p className='input-title'>Identidad de género</p>
              <input
                value={beneficiary?.genderIdentity}
                type='text'
                className='input-form'
                readOnly
              />
            </label>
            <label htmlFor='' className='scolarity'>
              <p className='input-title'>Orientación sexual</p>
              <input
                value={beneficiary?.sexualOrientation}
                type='text'
                className='input-form'
                readOnly
              />
            </label>
            <label htmlFor='' className='scolarity'>
              <p className='input-title'>Etnia</p>
              <input
                value={beneficiary?.ethnicity}
                type='text'
                className='input-form'
                readOnly
              />
            </label>
            <label htmlFor='' className='scolarity'>
              <p className='input-title'>Población víctima</p>
              <input
                value={beneficiary?.victimPopulation}
                type='text'
                className='input-form'
                readOnly
              />
            </label>

            <label htmlFor='' className='scolarity'>
              <p className='input-title'>Tiempo de desplazado (meses) </p>
              <input
                value={beneficiary?.timeDisplacement}
                type='text'
                className='input-form'
                readOnly
              />
            </label>
            <label htmlFor='' className='scolarity'>
              <p className='input-title'>Lugar de desplazamiento</p>
              <input
                value={beneficiary?.placeDisplacement}
                type='text'
                className='input-form'
                readOnly
              />
            </label>
          </div>

          <div className='differentialApproach'>
            <p className='title'>Enfoque diferencial</p>
            <div className='checkbox-container'>
              <label className='input-container' htmlFor={'inputA'}>
                <input className='checkbox-input' type='checkbox' id='inputA' />

                <span className='custom-checkbox'></span>
                <p className='name'>Situación de calle</p>
              </label>
              <label className='input-container' htmlFor={'inputB'}>
                <input className='checkbox-input' type='checkbox' id='inputB' />

                <span className='custom-checkbox'></span>
                <p className='name'>Campesino</p>
              </label>
            </div>
          </div>
          <div className='disabilitie-bottom-container'>
            <label htmlFor='' className='scolarity'>
              <p className='input-title'>Condición de discapacidad</p>
              <input
                value={beneficiary?.disabilitie}
                type='text'
                className='input-form'
                readOnly
              />
            </label>
            <label htmlFor='' className='scolarity'>
              <p className='input-title'>¿Tiene alguna enfermedad crónica?</p>
              <input
                value={beneficiary?.cronicDisabilitie}
                type='text'
                className='input-form'
                readOnly
              />
            </label>
            <label htmlFor='' className='scolarity '>
              <p className='input-title'>Nombre de la enfermedad</p>
              <input
                value={beneficiary?.nameDisabilitie}
                type='text'
                className='input-form disabilitie-name'
                readOnly
              />
            </label>
            <label htmlFor='' className='scolarity'>
              <p className='input-title'>Tratamiento de la enfermedad</p>
              <input
                value={beneficiary?.treatmentDisabilitie}
                type='text'
                className='input-form disabilitie-name'
                readOnly
              />
            </label>
          </div>
        </section>
        <section className='form-wrapper'>
          <label htmlFor='' className='scolarity'>
            <p className='input-title'>Problemática y factores de riesgo</p>
            <input
              value={beneficiary?.risksAndProblematics}
              type='text'
              className='input-form'
              readOnly
            />
          </label>
        </section>
        <section className='form-wrapper'>
          <label htmlFor=''>
            <p className='input-title'>Nombre completo del acudiente</p>
            <input
              value={beneficiary?.attendantName}
              type='text'
              readOnly
              className='input-form'
            />
          </label>

          <label htmlFor=''>
            <p className='input-title'>Celular</p>
            <input
              value={beneficiary?.attendantPhone}
              readOnly
              type='text'
              className='input-form'
            />
          </label>
          <label htmlFor=''>
            <p className='input-title'>Correo electrónico</p>
            <input
              readOnly
              value={beneficiary?.attendantEmail}
              placeholder='Cristina.cardona@gmail.com'
              type='email'
              className='input-form'
            />
          </label>
        </section>
        <section className='form-wrapper'>
          <label htmlFor=''>
            <p className='input-title'>Estado civil</p>
            <input
              readOnly
              value={beneficiary?.civilState}
              type='email'
              className='input-form'
            />
          </label>
          <label htmlFor=''>
            <p className='input-title'>Organización a la que pertenece</p>
            <input
              readOnly
              value={beneficiary?.organization}
              type='email'
              className='input-form'
            />
          </label>

          <label htmlFor=''>
            <p className='input-title'>Ocupación</p>
            <input
              readOnly
              value={beneficiary?.ocupation}
              type='email'
              className='input-form'
            />
          </label>
        </section>
        <section className='form-wrapper'>
          <label htmlFor='' className='scolarity'>
            <p className='input-title'>Talla camiseta</p>
            <input
              value={beneficiary?.shirtSize}
              type='text'
              className='input-form'
              readOnly
            />
          </label>
        </section>
      </section>
    </section>
  );
}
export default BeneficiariesAdmin;
